module.exports = __webpack_public_path__ + "static/media/8f062e48.jpg";